var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHMirrored = function SvgHMirrored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.971 11.003-6.5-3.753 6.5-3.753V6.6h10.184v1.3H10.971zm3.684 9.5 6.5-3.753-6.5-3.753V16.1H4.471v1.3h10.184z"
  })));
};
export { SvgHMirrored as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNCIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsUnVsZT0iZXZlbm9kZCI+CiAgPHBhdGggZD0iTTEwLjk3MSAxMS4wMDNsLTYuNS0zLjc1MyA2LjUtMy43NTNWNi42aDEwLjE4NHYxLjNIMTAuOTcxdjMuMTAzem0zLjY4NCA5LjVsNi41LTMuNzUzLTYuNS0zLjc1M1YxNi4xSDQuNDcxdjEuM2gxMC4xODR2My4xMDN6IiAvPgo8L3N2Zz4K";